import React, { useContext } from 'react';
import { RolePermissions, PermissionContext } from '../../../../../../appContext';
import { pages } from '../../../common/constant';
import PaymodeApproval from './PaymodeApproval';
import { PermisionDenied } from '../../../common/commonComponents';

const PaymodeApprovalPage = () => {

    const userPermissions = RolePermissions(useContext(PermissionContext), pages['paymodeApproval']['id']);
    return (
        userPermissions
            ? <PaymodeApproval userPermissions={userPermissions} />
            : <PermisionDenied />
    );
}

export default PaymodeApprovalPage;